<div class="headline">{{ headline() }}</div>
